import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'

const configLive = {
  apiKey: 'AIzaSyAj1tRgSxnaYTcJrE69WxzkoafnbHS3dyI',
  authDomain: 'plykea-mega-admin.firebaseapp.com',
  databaseURL: 'https://plykea-mega-admin.firebaseio.com',
  projectId: 'plykea-mega-admin',
  storageBucket: 'plykea-mega-admin.appspot.com',
  messagingSenderId: '830709651991'
}

const configDev = {
  apiKey: 'AIzaSyA7TU8M6fXLE2vJi-mDiE5Z-Vy7PocYMVU',
  authDomain: 'plykea-mega-admin-dev.firebaseapp.com',
  databaseURL: 'https://plykea-mega-admin-dev.firebaseio.com',
  projectId: 'plykea-mega-admin-dev',
  storageBucket: 'plykea-mega-admin-dev.appspot.com',
  messagingSenderId: '1056524756718'
}

const forceLive = false
const config = window.location.hostname == 'mega.plykea.com' || forceLive ? configLive : configDev

export const app = initializeApp(config)
export const db = getFirestore(app)
export const auth = getAuth(app)
export const functions = getFunctions(app)
